const reachGoalMetrika = (goal: string) => {
  try {
    // @ts-ignore
    ym(process.env.NEXT_PUBLIC_YM_ID, 'reachGoal', goal)
  } catch (e) {
    console.error(e)
  }
}

export default reachGoalMetrika
